export default {"src":"/_next/static/media/0x1dc78acda13a8bc4408b207c9e48cdbc096d95e0.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};